import React from "react";
import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "components/ProtectedRoute";
import DashboardLayout from "components/dashboard/DashboardLayout";
import {
  publicRoutes,
  protectedStandaloneRoutes,
  layoutRoutes,
  dashboardRoutes,
  notFoundRoute,
} from "./routeConfig";

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Routes - No authentication required */}
      {publicRoutes.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          element={<route.component />}
        />
      ))}

      {/* Protected Standalone Routes - No layout wrapper */}
      {protectedStandaloneRoutes.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          element={<ProtectedRoute component={route.component} />}
        />
      ))}

      {/* Layout Routes - Wrapped in Layout component */}
      {layoutRoutes.map((route) => {
        if (!route.layout) return null;
        const LayoutComponent = route.layout;
        return (
          <Route key={route.path} element={<LayoutComponent />}>
            <Route
              path={route.path}
              element={<ProtectedRoute component={route.component} />}
            />
          </Route>
        );
      })}

      {/* Dashboard Routes - Wrapped in DashboardLayout */}
      <Route element={<DashboardLayout />}>
        {dashboardRoutes.map((route) => (
          <Route
            key={route.path}
            path={route.path}
            element={
              <ProtectedRoute
                component={route.component}
                allowUnauthenticatedPaths={route.allowUnauthenticatedPaths}
              />
            }
          />
        ))}
      </Route>

      {/* 404 Not Found Route */}
      <Route path={notFoundRoute.path} element={<notFoundRoute.component />} />
    </Routes>
  );
};

export default AppRoutes;
